//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.ExtractAttributeBaseBuilder.js";
import "../no/Expression.js";
import "../no/AttributePropertiesBaseBuilder.js";
let d=[[[0,"CategoryName",1,0],[0,"Expression",1,"Expression",0],[0,"Mode",1,0],[0,"ObjectFromExp",0,"NXObject",0],[0,"PropertyDataType",1,0],[0,"PropertyName",1,0],[0,"SelectBaseDefinition",0,"AME.SelectionBaseDefinitionBuilder",0]],[[["numProxyObjects"],"CreateOrGetAttributeproxyObjects",{R_:{proxyObjects:"NXObject[]"}},0,0],[[],"GetSourceExpressionPart",{R_:{sourceExpressionPart:"Part"}},0,0]],[]];
SPLM.AME.ExtractAttributeRelativeBuilder = class extends SPLM.AME.ExtractAttributeBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ExtractAttributeRelativeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.ExtractAttributeRelativeBuilder.ModeValue = Object.freeze({
    "SelectProperty" : "SelectProperty", "ManualInput" : "ManualInput"});

export default SPLM;